import dateTimeHelper from '../Helpers/datetimeHelper';
import stringHelper from '../Helpers/stringHelper';
import React from 'react';
import RedirectLinkComponent from '../Elements/RedirectLinkComponent';
import FigmaBadge from '../Elements/FigmaBadge';
import LongText from '../Elements/LongText';

export default class EvaluatorAssignmentItem {
  constructor(item) {
    if (item === undefined) {
      this.AsId = '';
      this.AsSassieAsgnId = '';
      this.AsCfName = '';
      this.CuName = '';
      this.InCiid = '';
      this.Rcysymbol = '';
      this.Fee = '';
      this.FeeAddit = '';
      this.Reimbursement = '';
      this.Travel = '';
      this.Gaming = '';
      this.Misc = '';
      this.AsLdvname = '';
      this.InFieldworkFee = '';
      this.AsEvname = '';
      this.LgsDesc = '';
      this.AsEvaluatorCompletedDate = '';
      this.CuId = '';
      this.AsUninvoiceable = '';
      this.ClientId = '';
      this.ClientName = '';
      this.AsEvaluatorCompletedDateFormatted = '';
      this.AsPayEvaluator = '';
      this.AsBillClient = '';
      this.AsCfid = '';
      this.AsIeFee = '';
      this.AsIeFeeAdjustment = '';
      this.AsIeReimbursement = '';
      this.AsIeTravel = '';
      this.AsIeGaming = '';
      this.AsIeMisc = '';
      this.AsFee = '';
      this.CuCountry = '';
      this.EvaluatorCurrencyName = '';
      this.ReimbursementCurrencyName = '';
      this.Selected = false;
      this.ProjectIdAndName = '';
      return;
    }

    this.AsId = item.asId;
    this.AsSassieAsgnId = item.asSassieAsgnId;
    // The evaluator's assignment list sends asCfId/asCfName, the Excluded PS list (AssignmentExcludedResource) asCfid/asCfname.
    this.AsCfName = item.asCfName ?? item.asCfname ?? '';
    this.CuName = item.cuName;
    this.InCiid = item.inCiid;
    this.Rcysymbol = item.rcysymbol;
    this.Fee = item.fee;
    this.FeeAddit = item.feeAddit;
    this.Reimbursement = item.reimbursement;
    this.Travel = item.travel;
    this.Gaming = item.gaming;
    this.Misc = item.misc;
    this.AsLdvname = item.asLdvname;
    this.InFieldworkFee = item.inFieldworkFee;
    this.AsEvname = item.asEvname;
    this.LgsDesc = item.lgsDesc;
    this.AsEvaluatorCompletedDate = item.asEvaluatorCompletedDate;
    this.CuId = item.cuId;
    this.AsUninvoiceable = item.asUninvoiceable === true ? 'True' : 'False';
    this.FeeTotal = stringHelper.getFeeTotal(item.rcysymbol, [item.fee, item.feeAddit]);
    this.ReimbTotal = stringHelper.getFeeTotal(item.rcysymbol, [
      item.reimbursement,
      item.travel,
      item.gaming,
      item.misc,
    ]);
    this.ClientId = item.clientId;
    this.ClientName = item.clientName == null ? '' : item.clientName;
    this.AsEvaluatorCompletedDateFormatted = dateTimeHelper.toYYYYsMMsDD(item.asEvaluatorCompletedDate, '-');
    this.AsPayEvaluator = item.asPayEvaluator;
    this.AsBillClient = item.asBillClient;
    this.AsCfid = item.asCfId ?? item.asCfid ?? '';
    this.AsIeFee = item.asIeFee;
    this.AsIeFeeAdjustment = item.asIeFeeAdjustment;
    this.AsIeReimbursement = item.asIeReimbursement;
    this.AsIeTravel = item.asIeTravel;
    this.AsIeGaming = item.asIeGaming;
    this.AsIeMisc = item.asIeMisc;
    this.AsFee = item.asFee;
    this.CuCountry = item.cuCountry;
    this.EvaluatorCurrencyName = item.evaluatorCurrencyName;
    this.ReimbursementCurrencyName = item.reimbursementCurrencyName;
    this.ProjectIdAndName = this.AsCfid === '' ? '' : `${this.AsCfid} - ${this.AsCfName}`;
    this.Selected = false;
  }

  static NameOfTheIdField() {
    return 'AsId';
  }
  static nameOfTheItemDetailList() {
    return 'Assignment';
  }

  static MoneyFields = ['AsIeFee', 'AsIeFeeAdjustment', 'AsIeTravel', 'AsIeGaming', 'AsIeMisc', 'AsFee'];

  static numberWithTwoDecimalPlaces = [];

  static Currency() {
    return 'EvaluatorCurrencyName';
  }

  static MoneyFieldsSecondary = ['AsIeReimbursement'];

  static CurrencySecondary() {
    return 'ReimbursementCurrencyName';
  }

  static DateFields = [];

  static BoolFields = [];

  static idFunction(item) {
    return (
      <RedirectLinkComponent
        isFigmaStyle={true}
        path='assignments'
        tooltipText={item.AsSassieAsgnId}
        text={item.AsSassieAsgnId}
        keyValuePairs={[
          { key: 'AsBillClient', value: '' },
          { key: 'AsPayEvaluator', value: '' },
          { key: 'AsSassieAsgnId', value: item.AsSassieAsgnId },
        ]}
      />
    );
  }

  static badgeFunction(item) {
    return (
      <FigmaBadge
        Active={item}
        ActiveText='Yes'
        InactiveText='No'
        width={50}
      />
    );
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Apollo Job ID',
        orderById: 'AsSassieAsgnId',
        data: EvaluatorAssignmentItem.idFunction,
        minWidth: '80px',
      },
      { label: 'Client', orderById: 'ClientName', data: 'ClientName', minWidth: 50 },
      {
        label: 'Project',
        orderById: 'AsCfid',
        data: (item) => (
          <LongText
            text={item.ProjectIdAndName}
            maxLength={30}
          />
        ),
        minWidth: 100,
      },
      { label: 'Location', orderById: 'CuName', data: 'CuName', minWidth: 50 },
      { label: 'Invoice', orderById: 'InCiid', data: 'InCiid', minWidth: 60 },
      { label: 'Fee Total', orderById: 'FeeTotal', data: 'FeeTotal', minWidth: '80px' },
      { label: 'Reimb. Total', orderById: 'ReimbTotal', data: 'ReimbTotal', minWidth: '90px' },
      { label: 'FW Office', orderById: 'AsLdvname', data: 'AsLdvname' },
      { label: 'Status', orderById: 'LgsDesc', data: 'LgsDesc', minWidth: 60 },
      {
        label: 'PS',
        orderById: 'AsPayEvaluator',
        data: (item) => EvaluatorAssignmentItem.badgeFunction(item.AsPayEvaluator),
        minWidth: 20,
      },
      {
        label: 'BC',
        orderById: 'AsBillClient',
        data: (item) => EvaluatorAssignmentItem.badgeFunction(item.AsBillClient),
        minWidth: 20,
      },
      {
        label: 'Completed On',
        orderById: 'AsEvaluatorCompletedDateFormatted',
        data: 'AsEvaluatorCompletedDateFormatted',
      },
    ];
  }

  static FieldsToShowInListTable = [];
}
